import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import storage from '../../../services/stoage.service'
import utils, { getMessage } from '../../../utils'
import { actions, ENVIO_GERAR } from '../remessapagamento.actions'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { RemessaPagamentoForm } from './RemessaPagamentoForm'
import ContrassenhaDialog from '../../../components/contrassenha/ContrassenhaDialog'
import { buscarTelaContrassenha } from '../../../services/api-contrassenha'
import _ from 'lodash'

const mapStateToProps = (state) => {
  const messages = state.crudRemessaPagamentoState.messages
  const record = state.crudRemessaPagamentoState.currentRecord
  const item = state.crudRemessaPagamentoState.item
  const itens = state.crudRemessaPagamentoState.itens || []
  // PHOENIX-959: envio no ar ou com resultado incerto - Gerar travado (no store: sobrevive a sair e voltar da tela)
  const envioGerar = state.crudRemessaPagamentoState.envioGerar

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    let unidade = {
      id: currentUnit.oid,
      value: currentUnit.sigla,
    }
    Object.assign(record, { unidades: [unidade] })
    Object.assign(record, { unidade: unidade })
    disableUnit = true
  }

  const currentCompany = storage.getCompany()
  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(currentCompany)
  unidades = unidades.concat(unidadesEmpresa)

  return {
    currentCompany,
    record,
    item,
    messages,
    unidades,
    disableUnit,
    itens,
    envioGerar,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    setItem: (prop, value) => dispatch(actions.setItem(prop, value)),
    addItem: (payload) => dispatch(actions.addItem(payload)),
    onClickRemoveItem: (item) => dispatch(actions.onClickRemoveItem(item)),
    gerarRemessa: (data) => dispatch(actions.gerarRemessa(data)),
  }
}

class RemessaPagamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.hideBtnImportacao = true
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      contrassenhaVisivel: false,
      // texto do aviso de resultado incerto, do back (o dicionario do front nao traz os textos da contrassenha)
      avisoIncerto: '',
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    this.montado = true
    logarAcesso().then()
    this.carregarAvisoIncerto()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.envioGerar !== this.props.envioGerar) {
      this.carregarAvisoIncerto()
    }
  }

  componentWillUnmount() {
    this.montado = false
  }

  // resultado incerto (tambem ao voltar para a tela): busca o texto do aviso no back, o mesmo do dialogo
  carregarAvisoIncerto = () => {
    if (this.props.envioGerar !== ENVIO_GERAR.INCERTO || this.state.avisoIncerto) {
      return
    }
    buscarTelaContrassenha()
      .then(({ data }) => {
        if (this.montado) {
          this.setState({ avisoIncerto: _.get(data, 'textos.resultadoDesconhecido', '') || '' })
        }
      })
      .catch(() => null)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  // PHOENIX-959: a remessa paga de verdade; so sai depois da contrassenha (conferida no back)
  gerar = () => {
    if (this.props.envioGerar) {
      return
    }
    this.setState({ contrassenhaVisivel: true })
  }

  fecharContrassenha = () => {
    this.setState({ contrassenhaVisivel: false })
  }

  confirmarContrassenha = (contrassenha) => {
    const data = {
      unidade: this.props.record.unidade,
      contaCorrente: this.props.record.contaCorrente,
      dataPagamento: this.props.record.dataPagamento,
      itens: this.props.itens,
      contrassenha,
    }
    return this.props.gerarRemessa(data).then(() => this.fecharContrassenha())
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button
          label={utils.getMessage(this.props.messages, 'remessapagamento.label.gerar')}
          icon="pi pi-check"
          className="p-button-success"
          onClick={this.gerar}
          disabled={!!this.props.envioGerar}
        />
      </div>
    )
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'remessapagamento.label.titulo')}
      />
    )
  }

  render() {
    // resultado incerto: o dialogo ja fechou; sem isto sobraria so o Gerar desabilitado, sem dizer por que
    const avisoIncerto = this.props.envioGerar === ENVIO_GERAR.INCERTO ? this.state.avisoIncerto : null
    const content = (
      <div>
        {avisoIncerto ? <Message severity="warn" text={avisoIncerto} style={{ marginBottom: '1em' }} /> : null}
        <RemessaPagamentoForm
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          changeHandler={this.props.changeHandler}
          record={this.props.record}
          item={this.props.item}
          disableUnit={this.props.disableUnit}
          unidades={this.props.unidades}
          setField={this.props.setField}
          itens={this.props.itens}
          addItem={this.props.addItem}
          setItem={this.props.setItem}
          onClickRemoveItem={this.props.onClickRemoveItem}
        />
        <ContrassenhaDialog
          visible={this.state.contrassenhaVisivel}
          onConfirmar={this.confirmarContrassenha}
          onCancelar={this.fecharContrassenha}
        />
      </div>
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RemessaPagamentoFormPageContainer)
